export default {
  path: '/distributors',
  name: 'distributors',
  component: () => import('../components/distributor/Layout'),
  redirect: { name: 'DistributorList' },
  meta: {
    breadcrumb: 'qualitycheck.distributor.distributors',
  },
  children: [
    {
      name: 'DistributorList',
      path: '',
      component: () => import('../views/distributor/List'),
      meta: {
        breadcrumb: 'global.list',
      },
    },
    {
      name: 'DistributorCreate',
      path: 'new',
      component: () => import('../views/distributor/Create'),
      meta: {
        breadcrumb: 'global.add',
      },
    },
    {
      name: 'DistributorUpdate',
      path: ':id/edit',
      component: () => import('../views/distributor/Update'),
      meta: {
        breadcrumb: 'qualitycheck.distributor.distributor',
      },
    },
    {
      name: 'DistributorShow',
      path: ':id',
      component: () => import('../views/distributor/Show'),
      meta: {
        breadcrumb: 'qualitycheck.distributor.distributor',
      },
    }
  ]
};
